import LegalLayout from "./LegalLayout";
export default function GiocoResponsabile() {
  return (
    <LegalLayout title="Gioco responsabile">
      <p>Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica.</p>
      <p>Gioca responsabilmente. Stabilisci un budget, non inseguire le perdite e prenditi delle pause.</p>
      <p>Per informazioni e supporto: telefono verde ADM 800 55 88 22.</p>
    </LegalLayout>
  );
}
